import React, { Suspense } from "react";
import Sidebar from "../sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import AppHeader from "../header/Navbar";
import { Layout } from "antd";
import AppContainer from "../conatiner/Conatiner";
import FallBackLoading from "../Loader/FallbackLoading";
import AppSecureStorage from "../../services/secureStorage";

const AppLayout = ({ routers }) => {
  const location = useLocation();
  const normalizePath = (path = "") =>
    path.length > 1 ? path.replace(/\/+$/, "") : path;

  const currentRoute = routers.find(
    (route) => normalizePath(route.path) === normalizePath(location.pathname)
  );
  const isAuthenticated = () => {
    const storage = new AppSecureStorage();
    const tokenExpiry = storage.get("tokenExpiry");
    return Boolean(storage.get("token")) && new Date() < new Date(tokenExpiry);
  };
  // Public routes flagged with SideNavWhenAuthenticated show the nav only when logged in
  const showSideNav =
    currentRoute?.SideNav ||
    (currentRoute?.SideNavWhenAuthenticated && isAuthenticated()) ||
    false;

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        {showSideNav && <AppHeader />}
        <Layout className="site-layout">
          {showSideNav && <Sidebar />}
          <Suspense fallback={<FallBackLoading />}>
            <AppContainer showSideNav={showSideNav} />
          </Suspense>
        </Layout>
      </Layout>
    </>
  );
};

export default AppLayout;
